
import { useParams } from "react-router-dom";
import { SidebarProvider } from "@/components/ui/sidebar";
import DashboardSidebar from "@/components/DashboardSidebar";
import { MaintenancePlanner } from "@/components/vehicle/MaintenancePlanner";

const MaintenanceHistoryPage = () => {
  const { id } = useParams();

  if (!id) return null;

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <DashboardSidebar />
        <main className="flex-1 p-8 bg-gray-50">
          <div className="max-w-5xl mx-auto space-y-8">
            <h1 className="text-2xl font-semibold">Afspraak maken</h1>
            <MaintenancePlanner vehicleId={id} showHistory={false} />
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
};

export default MaintenanceHistoryPage;
